// extracted by mini-css-extract-plugin
export default {"appSwiper":"AppSwiper_appSwiper__0lZqQ","singleSlide":"AppSwiper_singleSlide__XTpMQ","button":"AppSwiper_button__JDd-I","next":"AppSwiper_next__BiRBb","prev":"AppSwiper_prev__guEgI"};